import { gql } from '@apollo/client';
// local imports
import { API_MY_LINKEDIN_IMPORT } from '../config/api';

export const LINKEDIN_PROFILE_IMPORT = gql`
  mutation LinkedinProfileImport(
    $input: LinkedInProfileImportInput!
  ) {
    linkedinProfileImport(
      input: $input
    )
    @rest(
      type: "MutationResponse",
      path: "${API_MY_LINKEDIN_IMPORT}",
      method: "POST"
    ) {
      success
    }
  }
`;
